module.exports = __webpack_public_path__ + "img/face-woozy.674e693b.svg";